<p [class.guts-p-b-half]="!isLast" *ngIf="!!value">
  <span class="par--small par--light guts-p-r-1">{{ title }}</span>
  <span *ngIf="isText" class="par--small font-medium">{{ value }}</span>

  <a
    *ngIf="isLink"
    href="{{ href }}"
    class="link"
    target="none"
    aria-describedby="a11yNewWindowDescription"
    data-dgat="achievement-detail-5f2"
    rel="noopener noreferrer"
  >
    {{ value }}
    <df-icon icon="arrow-up-right-out" size="small" class="link"></df-icon>
  </a>

  <button
    *ngIf="isAttachment"
    class="link"
    aria-describedby="a11yNewWindowDescription"
    data-dgat="achievement-detail-c41"
    (click)="click($event)"
  >
    {{ value }}
    <df-icon icon="paperclip" size="small" class="link rotate-icon"></df-icon>
  </button>

  <span
    *ngIf="isClamped"
    class="guts-m-t-1 guts-m-b-1-half par par--small font-medium"
    [dgxLineClampText]="value"
    [clampLinesMax]="8"
  ></span>
</p>
